export default __webpack_public_path__ + "static/layerdoublebend-060f9778341908e0a427e2ed677a1abc.png";